module.exports = __webpack_public_path__ + "img/img_title_dynamic.751c2e94.png";